export default __webpack_public_path__ + "static/media/kakaologin.af437b99.svg";